export const bsctest = async () => {
    return BigInt(10n);
}

